import React from 'react'
import { Button, GridColumn } from 'semantic-ui-react'
import BenAdminAlternateSubmissionModal from './modal/BenAdminAlternateSubmissionModal'
import PlanMemberAlternateSubmissionModal from './modal/PlanMemberAlternateSubmissionModal'

export default function AlternateSubmission ({ employeeOnly }) {
  return <GridColumn width={16}>
    <h3>Alternate Submission</h3>
    <p>Access a PDF version of the Evidence of Insurability form to print and mail in for processing.</p>
    <span>I am a:&nbsp;&nbsp;</span>
    {employeeOnly ? <Button content='Plan Member (Employee)' /> :
      <Button.Group size='huge'>
        <PlanMemberAlternateSubmissionModal
          trigger={<Button content='Plan Member (Employee)' />}
        />
        <Button.Or />
        <BenAdminAlternateSubmissionModal
          trigger={<Button content='Benefit Administrator' />}
        />
      </Button.Group>
    }
  </GridColumn>
}